<h1>Manage agents</h1>
@defer (when agentsLoaded()) {
  <app-agent-table
    [showTableDetails]="true"
    [(gridData)]="gridView"
    [excelFileName]="'Manage-Agents.xlsx'"
    [tableColumns]="[
    { field: 'name', title: 'Name', width: 300 },
    { field: 'description', title: 'Description' },
    { field: 'isDisabled', title: 'Disabled', width: 120 },
    { field: 'isUniversal', title: 'Universal', width: 120 },
    { field: 'ownerList', title: 'Owners', hidden: true },
    { field: 'userList', title: 'Users', hidden: true },
    { field: 'groupList', title: 'Groups', hidden: true },
    { field: 'sensitivityLabelList', title: 'Sensitivity Label', hidden: true },
   ]"/>
} @placeholder {
  <div class="loading-placeholder">Loading agents...</div>
}
